export default " <!-- <p class=text-white>loading..........</p> -->\n <app-loader></app-loader>\n\n <router-outlet></router-outlet>\n\n"